import { render } from "./BrandLoves.vue?vue&type=template&id=6b9875fe&scoped=true"
import script from "./BrandLoves.vue?vue&type=script&lang=js"
export * from "./BrandLoves.vue?vue&type=script&lang=js"

import "./BrandLoves.vue?vue&type=style&index=0&id=6b9875fe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9875fe"]])

export default __exports__